// DATA METRICS ACTION TYPES

// Account Types
export const FETCH_ACCOUNT_TYPES_METRICS_REQUEST = 'FETCH_ACCOUNT_TYPES_METRICS_REQUEST';
export const FETCH_ACCOUNT_TYPES_METRICS_SUCCESS = 'FETCH_ACCOUNT_TYPES_METRICS_SUCCESS';
export const FETCH_ACCOUNT_TYPES_METRICS_FAILURE = 'FETCH_ACCOUNT_TYPES_METRICS_FAILURE';

// New Accounts
export const FETCH_NEW_ACCOUNTS_METRICS_REQUEST = 'FETCH_NEW_ACCOUNTS_METRICS_REQUEST';
export const FETCH_NEW_ACCOUNTS_METRICS_SUCCESS = 'FETCH_NEW_ACCOUNTS_METRICS_SUCCESS';
export const FETCH_NEW_ACCOUNTS_METRICS_FAILURE = 'FETCH_NEW_ACCOUNTS_METRICS_FAILURE';

// Clear errors
export const CLEAR_DATA_METRICS_ERRORS = 'CLEAR_DATA_METRICS_ERRORS';